import { TableSelectionColumnParams } from '@models/table.model.ts';
import { LiveTvModel } from '@modules/entertainment/models/live-tv.models.ts';
import { Tooltip } from '@mui/material';
import AppImage from '@components/app-image/app-image.tsx';
import RowActions from '@components/row-actions/row-actions.tsx';
import { liveTvFilterStatusOptions, LiveTvStatusMap, playerOptions } from '@modules/entertainment/utils/live-tv.utils.ts';
import { getSelectColumn } from '@utils/table-selection.utils.tsx';

export const liveTvColumns = (
  handleEdit: (row: any) => void,
  handleDelete: (row: any) => void,
  selection: TableSelectionColumnParams<LiveTvModel>,
  categoryList: { id: string; name: string }[]
) => [
    getSelectColumn<LiveTvModel>(selection),
    {
      id: 'channelNumber',
      label: 'column_label_channel_number',
      field: 'channelNumber',
      render: (value: any) => (
        <Tooltip title={value} followCursor>
          <span>{value !== null && value !== undefined ? value : 'N/A'}</span>
        </Tooltip>
      ),
      showSort: false,
      showSearch: true,
      showFilter: false,
      isTranslated: false
    },
    {
      id: 'image',
      label: 'column_label_channel_logo',
      field: 'image',
      render: (value: any) => (
        <div
          className={`h-13 w-13 rounded-md border border-(--gray-7) overflow-hidden cursor-pointer`}
        >
          <AppImage imgClassName="!h-full" filePath={value ?? undefined} />
        </div>
      ),
      showSort: false,
      showSearch: false,
      showFilter: false,
      isTranslated: false
    },
    {
      id: 'title',
      label: 'column_label_title',
      field: 'title',
      render: (value: any) => (
        <Tooltip title={value} followCursor>
          <span>{value || ''}</span>
        </Tooltip>
      ),
      showSort: false,
      showSearch: true,
      showFilter: false,
      isTranslated: false
    },
    {
      id: 'url',
      label: 'column_label_url',
      field: 'url',
      render: (value: any) => (
        <Tooltip title={value} followCursor>
          <span>{value || ''}</span>
        </Tooltip>
      ),
      showSort: false,
      showSearch: true,
      showFilter: false,
      isTranslated: false
    },
    {
      id: 'isEnabled',
      label: 'column_label_status',
      field: 'isEnabled',
      render: (value: boolean) => {
        const status = LiveTvStatusMap[String(value) as 'true' | 'false'];

        return (
          <Tooltip title={status?.text || value} followCursor>
            <span style={{ color: status?.color || 'inherit', fontWeight: 500 }}>
              {status?.text || value}
            </span>
          </Tooltip>
        );
      },
      showSort: false,
      filterData: liveTvFilterStatusOptions,
      showSearchInput: false,
      showFilter: true
    },
    {
      id: 'country',
      label: 'column_label_country',
      field: 'country',
      render: (value: any) => (
        <Tooltip title={value} followCursor>
          <span>{value || ''}</span>
        </Tooltip>
      ),
      showSort: false,
      showSearch: true,
      showFilter: false,
      isTranslated: false
    },
    {
      id: 'categories',
      label: 'column_label_category',
      field: 'categories',
      render: (value: any[]) => {
        const names = (value || [])
          .map((cat: any) => cat.title)
          .filter(Boolean)
          .join(', ');

        return (
          <Tooltip title={names || 'N/A'} followCursor>
            <span>{names || 'N/A'}</span>
          </Tooltip>
        );
      },
      showSort: false,
      filterData: categoryList.map((c) => ({ title: c.name, value: c.id })),
      showSearchInput: false,
      showFilter: true
    },
    {
      id: 'player',
      label: 'column_label_player',
      field: 'player',
      render: (value: any) => (
        <Tooltip title={value} followCursor>
          <span>{value || ''}</span>
        </Tooltip>
      ),
      showSort: false,
      showSearch: false,
      showFilter: true,
      filterData: playerOptions,
      isTranslated: false
    },
    {
      id: 'createdAt',
      label: 'column_label_date',
      field: 'createdAt',
      render: (value: any) => (
        <Tooltip
          title={value ? new Date(value).toLocaleDateString() : 'N/A'}
          followCursor
        >
          <span>{value ? new Date(value).toLocaleDateString() : 'N/A'}</span>
        </Tooltip>
      ),
      showSort: true,
      showSearch: false,
      showFilter: false,
      isTranslated: false
    },
    {
      id: 'Action',
      label: 'column_label_actions',
      field: 'actions',
      render: (value: any, row: string) => (
        <RowActions<any>
          row={row}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
        />
      ),
      showSort: false,
      showSearch: false,
      showFilter: false
    }
  ];
